import { CardContent } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { NumberInput } from '@/components/ui/number-input'
import { CompactToggle } from '@/components/ui/toggle-setting'
import PlanCardShell from '@/components/plan/PlanCardShell'
import PlanFieldDelta from '@/components/plan/PlanFieldDelta'

export default function AfterTaxCard({ id, title, description, reference, compareTo, afterTax, onAllowedChange, onMaxPercentChange, onMaxDollarChange, disabled, variant }) {
  const { allowed, maxPercent = 0, maxDollar = 0 } = afterTax || {}
  const showDelta = Boolean(compareTo?.allowed && allowed)
  return (
    <PlanCardShell
      id={id}
      disabled={disabled}
      variant={variant}
      title={title}
      description={description}
      titleAction={() => onAllowedChange(!allowed)}
      titleActionLabel="Toggle after-tax contributions"
      titleActionDisabled={disabled}
      headerAction={<CompactToggle label="Include after-tax contributions in plan" checked={allowed} onCheckedChange={onAllowedChange} disabled={disabled} />}
      collapsible={false}
    >
      {(reference || allowed) && <CardContent className="space-y-3">
        {reference}
        {allowed && (
          <div className="space-y-3 rounded-md bg-muted/30 p-3">
            <div className="grid grid-cols-[repeat(auto-fit,minmax(9rem,1fr))] gap-3">
              <div className="space-y-1">
                <Label htmlFor={`${id}-max-pct`}>Max % of comp<PlanFieldDelta value={maxPercent} compareValue={compareTo?.maxPercent} show={showDelta} format="percent" /></Label>
                <NumberInput id={`${id}-max-pct`} validationLabel="Max after-tax (% of comp)" value={maxPercent || ''} onValueChange={onMaxPercentChange} emptyValue={0} min={0} step="1" placeholder="No cap" />
              </div>
              <div className="space-y-1">
                <Label htmlFor={`${id}-max-dollar`}>Max $<PlanFieldDelta value={maxDollar} compareValue={compareTo?.maxDollar} show={showDelta} format="currency" /></Label>
                <NumberInput id={`${id}-max-dollar`} validationLabel="Max after-tax ($)" value={maxDollar || ''} onValueChange={onMaxDollarChange} emptyValue={0} min={0} step="500" placeholder="No cap" />
              </div>
            </div>
            <p className="text-xs text-muted-foreground">0 or blank means no plan cap; the 415(c) limit still applies. The cap is your main lever on the ACP spread – see “After-tax ACP risk” under Checks.</p>
            <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-900">
              <span className="font-semibold">Compliance: </span>
              After-tax contributions are ACP-tested (§401(m)) with match and aren’t exempted by safe harbor – concentrated highly-compensated use can raise ACP testing concerns. Confirm your plan document and recordkeeper support after-tax contributions and any Roth conversion.
            </div>
          </div>
        )}
      </CardContent>}
    </PlanCardShell>
  )
}
